// extracted by mini-css-extract-plugin
export default {"framework-selector":"V_bS d-flex","framework-selector__icon":"V_bT","framework-selector__option":"V_bV p-2 flex-grow-1 ml-2","framework-selector__option--selected":"V_bW"};